
<h1 mat-dialog-title>Confirmation</h1>
<div mat-dialog-content>
  <p>{{ message }}</p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">No</button>
  <button mat-button [mat-dialog-close]="true">Yes</button>
</div>
